import React, { useState, useContext, useEffect } from "react";
import styles from "./StudentRegistrations.module.css";
import moment from "moment";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Alert,
  Radio,
  Upload,
  Divider,
  Modal,
  DatePicker,
  Select,
  Space,
  message,
} from "antd";
import ImgCrop from "antd-img-crop";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  AddNewRower,
  GetOldRowerDetails,
  GetFullFileURL,
} from "../../APIManager";
import { GetAgeBracketInfo } from "../../utility";
import { ConfigContext } from "../../ConfigContext";

import PhotoProcessingModal from "../PhotoProcessingModal/PhotoProcessingModal";
import PhotoFileUpload from "../FaceAPI/PhotoFileUpload/PhotoFileUpload";

import {
  loadFaceApiModels,
  validatePhotoRequirements,
  validatePhotoRequirementsSDDModel,
  PhotoErrorMessages,
  loadFaceApiSSDModel,
} from "../FaceAPI/FaceAPI";

const { Option } = Select;
const { confirm } = Modal;
const AddNewStudent = ({ visible, onSubmit, onCancel }) => {
  const [form] = Form.useForm();
  let [config, setConfig] = useContext(ConfigContext);
  const [studentNationality, SetStudentNationality] = useState("Pakistani");
  const [isKBCMember, SetIsKBCMember] = useState("Not Member");
  const [isCox, SetIsCox] = useState(false);
  const [submitEnabled, SetSubmitEnabled] = useState(false);

  const [errorMessage, SetErrorMessage] = useState();
  const [showErrorMessage, SetShowErrorMessage] = useState(false);
  const [waitingOnResponse, SetWaitingOnResponse] = useState(false);

  const [oldRower, SetOldRower] = useState(null);

  const {
    U25YOBLowerLimit,
    U21YOBLowerLimit,
    U18YOBLowerLimit,
    U15YOBLowerLimit,
  } = GetAgeBracketInfo(config.cpConfig);

  const constFields = [
    "StudentFullName",
    "StudentYOB",
    "StudentGender",
    "StudentEmailAddress",
    //"StudentPicture",
    "StudentNationality",
    //"StudentCNIC",
    "StudentCNICNumber",
    //"StudentDeclaration",
    "KBCMember",
    "PreviousRegatta",
  ];
  const [requiredFields, SetRequiredFields] = useState([
    "StudentFullName",
    "StudentYOB",
    "StudentGender",
    //"StudentPicture",
    //"StudentCNIC",
    "StudentCNICNumber",
    "StudentEmailAddress",
    "StudentNationality",
    //"StudentDeclaration",
    "KBCMember",
    "PreviousRegatta",
  ]);

  React.useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
    form.setFieldsValue({
      StudentNationality: "Pakistani",
    });
  }, [visible]);

  const onFinish = (values) => {
    confirm({
      title: "Confirm",
      icon: <ExclamationCircleOutlined />,
      content: "Confirm you want to add this student",
      okText: "Submit New Student",
      okType: "primary",
      cancelText: "Back",
      onOk() {
        SetWaitingOnResponse(true);
        AddNewRower(form.getFieldsValue())
          .then((res) => {
            onSubmit();
            SetWaitingOnResponse(false);
          })
          .catch(() => {
            SetShowErrorMessage(true);
            message.warning(
              "A Server/Network Error Occured, please check your connection"
            );
            SetWaitingOnResponse(false);
          });
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    var fields = constFields;
    if (isCox) {
      fields.push("CoxSeminar", "CoxTest", "CoxPreviousRegatta");
    } else {
      form.resetFields(["CoxSeminar"]);
      form.resetFields(["CoxTest"]);
      form.resetFields(["CoxPreviousRegatta"]);
    }
    if (isKBCMember === "Rowing Member" || isKBCMember === "Regular Member") {
      fields.push("StudentKBCNumber");
    } else {
      form.resetFields(["StudentKBCNumber"]);
    }
    SetRequiredFields(fields);
  }, [isCox, isKBCMember]);

  useEffect(() => {
    const loadModels = async () => {
      const { error, message: modelMessage } = await loadFaceApiModels();
      if (error) {
        message.error(modelMessage); // Ant Design message
      } else {
        message.success(modelMessage);
      }
    };

    loadModels();
  }, []);

  const handleFormValuesChange = (changedValues) => {
    const fieldName = Object.keys(changedValues)[0];

    if (fieldName === "KBCMember") {
      const value = changedValues[fieldName];
      SetIsKBCMember(value);
    }
    if (fieldName === "COX") {
      const value = changedValues[fieldName];
      SetIsCox(value);
    }
  };

  function onModalCancel() {
    confirm({
      title: "Unsaved Progress",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to cancel. Data entered will be lost",
      okText: "Cancel New Student",
      okType: "primary",
      cancelText: "Back",
      onOk() {
        onCancel();
      },
      onCancel() {},
    });
  }

  async function FetchOldRowerDetails(e) {
    const cnic = e.target.value;
    GetOldRowerDetails(cnic).then(async (res) => {
      const details = res.data;
      if (details.length > 0) {
        var mostRecentRecord = [...details].sort((a, b) =>
          b.Year.localeCompare(a.Year)
        )[0];
        var rower = mostRecentRecord.Rower;
        console.log(rower);

        // --- 🎯 Logic to create file list object for DISPLAY ---
        let cnicFileList = [];
        // Assuming rower.CNICFileUrl contains the URL of the old CNIC file
        if (rower.CNICFileUrl) {
          cnicFileList.push({
            uid: "-1", // Unique ID
            name: "Previous CNIC File", // Display name
            fileYear: mostRecentRecord.Year,
            status: "done", // Status for display
            url: GetFullFileURL(rower.CNICFileUrl), // The URL for download/preview
            // Setting the originFileObj/response to the URL for file list rendering
            originFileObj: { url: rower.CNICFileUrl },
          });
        }
        // ----------------------------------------------------

        form.setFieldsValue({
          StudentFullName: rower.Name,
          StudentYOB: rower.YOB,
          StudentGender: rower.Gender,
          StudentPhoneNumber: rower.PhoneNumber,
          KBCMember: rower.KBCMember,
          StudentKBCNumber: ["Regular Member", "Rowing Member"].includes(
            rower.KBCMember
          )
            ? rower.KBCNumber
            : null,

          // Set the form value to the file list object for initial display
          StudentCNIC: cnicFileList.length > 0 ? cnicFileList : null,

          PreviousRegatta: true,
        });
        SetIsKBCMember(rower.KBCMember);

        SetOldRower(rower);

        try {
          await form.validateFields();
        } catch (err) {
          // Validation failed, errors will show on fields
        }

        message.success("Fetched rower details from previous ISR");
      } else {
        message.error("No previous registration found for this CNIC/Passport");
      }
    });
  }

  return (
    <Modal
      title="Add New Student"
      forceRender
      visible={visible}
      onOk={onSubmit}
      onCancel={onModalCancel}
      okText="Submit"
      cancelText="cancel"
      width="800px"
      okButtonProps={{
        hidden: true,
      }}
      cancelButtonProps={{ hidden: true }}
      maskClosable={false}
    >
      <Form
        form={form}
        layout={"vertical"}
        size="large"
        onValuesChange={handleFormValuesChange}
        onChange={(form) => {}}
        autoComplete={false}
        onFinish={onFinish}
      >
        <Form.Item
          label="Nationality"
          name="StudentNationality"
          rules={[{ required: true, message: "Please input Nationality" }]}
        >
          <NationalitySelect SetStudentNationality={SetStudentNationality} />
        </Form.Item>
        <CNICInput
          nationality={studentNationality}
          onPressEnter={FetchOldRowerDetails}
        />
        Press enter on your keyboard to autofill form details from any previous
        registration
        <Form.Item
          label="Student Full Name (must be identical to submitted ID document)"
          name="StudentFullName"
          rules={[
            { required: true, message: "Please input Student Full Name" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Student Year of Birth"
          name="StudentYOB"
          shouldUpdate
          rules={[
            { required: true, message: "Please input Student Year of Birth" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || !(value < U25YOBLowerLimit || value > 2021)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    `Please enter a valid DOB between ${U25YOBLowerLimit} and 2021`
                  )
                );
              },
            }),
          ]}
        >
          <CategorySelect />
        </Form.Item>
        <Form.Item
          label="Gender"
          name="StudentGender"
          rules={[{ required: true, message: "Please input Gender" }]}
        >
          <Select>
            <Option value="Male">Male</Option>
            <Option value="Female">Female</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Email Address"
          name="StudentEmailAddress"
          rules={[
            {
              required: true,
              message: "Please input student's Email Address",
            },
            { type: "email", message: "Please enter a valid Email Address" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Student Phone Number"
          name="StudentPhoneNumber"
          rules={
            [
              /*  {
              pattern: new RegExp(/^03[0-9]{2}[0-9]{7}$/),
              message: "Please enter a valid number in the format: 03001234567",
            }, */
            ]
          }
        >
          <Input />
        </Form.Item>
        <div>
          Student Photograph Requirements
          <ol>
            <li>
              Photo must be a soft copy of a photograph provided by a
              professional photographer. Snapshots/scans of hard copy
              photographs will not be accepted
            </li>
            <li>Photo must meet NADRA requirements</li>
            <li>Photo must not be older than 6 months</li>
            <li>Format must be JPEG/JPG/PNG</li>
            <li>
              Once uploaded, please adjust photo so that the candidate’s head
              fills the marked space
            </li>
          </ol>
        </div>
        <Form.Item
          name="StudentPicture"
          label="Student Photograph"
          /*  rules={[
            {
              required: true,
              message: "Please upload Student Picture",
            },
          ]} */
          className="CustomImageUpload"
        >
          <PhotoFileUpload />
        </Form.Item>
        <Form.Item
          label="Upload Scanned CNIC/Smart Card/Passport"
          name="StudentCNIC"
          /*  rules={[
            {
              required: true,
              message: "Please upload Scanned CNIC/Smart Card/Passport",
            },
          ]} */
        >
          <FileUpload />
        </Form.Item>
        <Form.Item
          label="Upload Scanned Student Declaration"
          name="StudentDeclaration"
          /*  rules={[
            {
              required: true,
              message: "Please upload Scanned Student Declaration",
            },
          ]} */
        >
          <FileUpload />
        </Form.Item>
        <Form.Item
          label={"KBC Membership Status"}
          name={"KBCMember"}
          rules={[
            {
              required: true,
              message: "Please seelect either 'Yes' or 'No'",
            },
          ]}
        >
          <Select>
            <Option value="Not Member">Not Member</Option>
            <Option value="Application in Process">
              Application in Process
            </Option>
            <Option value="Module">Module</Option>
            <Option value="Rowing Member">Rowing Member</Option>
            <Option value="Regular Member">Regular Member</Option>
          </Select>
        </Form.Item>
        {isKBCMember === "Regular Member" || isKBCMember === "Rowing Member" ? (
          <Form.Item
            label="Student KBC Membership Number"
            name="StudentKBCNumber"
            dependencies={["KBCMember"]}
            rules={[
              {
                required: isKBCMember,
                message: "Please input your Student KBC Membership Number",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  var rowingregex1 = /^[9][0-9]{4}$/;
                  var rowingregex2 = /^[9][9][0-9]{4}$/;
                  var regularregex1 = /^[0-9]{4}$/;
                  if (isKBCMember === "Rowing Member") {
                    if (
                      !value ||
                      rowingregex1.test(value) ||
                      rowingregex2.test(value)
                    ) {
                      return Promise.resolve();
                    }
                  } else {
                    if (!value || regularregex1.test(value)) {
                      return Promise.resolve();
                    }
                  }
                  return Promise.reject(
                    new Error(`Please enter a valid Membership Number`)
                  );
                },
              }),
            ]}
          >
            <Input />
          </Form.Item>
        ) : null}
        <Form.Item
          label={"Has student taken part in any previous KBC Regatta?"}
          name={"PreviousRegatta"}
          rules={[
            {
              required: true,
              message: "Please select either 'Yes' or 'No'",
            },
          ]}
        >
          <Radio.Group>
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item shouldUpdate={true}>
          {() => {
            return (
              <Space
                style={{ justifyContent: "flex-end", width: "100%" }}
                width="100%"
                align="end"
              >
                <Button type="default" onClick={onModalCancel}>
                  Cancel
                </Button>
                <Button
                  size={"large"}
                  block
                  type="primary"
                  htmlType="submit"
                  disabled={
                    // 🎯 UPDATED LOGIC HERE:
                    // 1. Check if fields have values (instead of if they are touched)
                    !checkRequiredFieldsFilled(form, requiredFields) ||
                    // 2. Check for validation errors
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length ||
                    // 3. Check network status
                    waitingOnResponse
                  }
                >
                  Submit
                </Button>
              </Space>
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddNewStudent;
const CNICInput = ({ nationality, onPressEnter }) => {
  var isPaki = nationality === "Pakistani";

  const onSearch = (value) => {
    onPressEnter({ target: { value } });
  };

  return (
    <Form.Item
      label={`Student ${isPaki ? "Citzenship Number" : "Passport Number"}`}
      name="StudentCNICNumber"
      rules={[
        {
          required: true,
          message: `Please enter Student ${
            isPaki ? "Citzenship Number" : "Passport Number"
          }`,
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            var cnicRegex = new RegExp(/^((\d{5}-\d{7})|(\d{6}-\d{6}))-[0-9]$/);
            if (!value || !isPaki || cnicRegex.test(value)) {
              return Promise.resolve();
            }
            return Promise.reject(
              new Error(
                `Please enter a valid CNIC in the format 42301-1234567-8`
              )
            );
          },
        }),
      ]}
    >
      <Input.Search
        placeholder={isPaki ? "42301-1234567-8" : "Passport Number"}
        enterButton="Fetch Details"
        onSearch={onSearch}
      />
    </Form.Item>
  );
};
function requiredFieldsTouched(form, requiredFields) {
  var returnValue = true;
  requiredFields.forEach((element) => {
    if (!form.isFieldsTouched([element])) {
      returnValue = false;
    }
  });
  return returnValue;
}

function checkRequiredFieldsFilled(form, requiredFields) {
  // Check if every required field has a valid value
  return requiredFields.every((field) => {
    const value = form.getFieldValue(field);

    // We check that the value is not undefined, null, or an empty string.
    // Crucially, we allow 'false' (boolean) and '0' (numbers) as valid inputs.
    return value !== undefined && value !== null && value !== "";
  });
}

const CategorySelect = ({ value, onChange }) => {
  const [config] = useContext(ConfigContext);
  const momentObj = moment(`${value}-01-01`, "YYYY-MM-DD");

  return (
    <div>
      <DatePicker
        allowClear={false}
        picker="year"
        onChange={(v) => {
          onChange(v?.year());
        }}
        value={momentObj}
      />
      {value ? (
        <div>Student Category: {YOBCategory(value, config)}</div>
      ) : (
        <></>
      )}
    </div>
  );
};

function YOBCategory(DOB, config) {
  const {
    U25YOBLowerLimit,
    U21YOBLowerLimit,
    U18YOBLowerLimit,
    U15YOBLowerLimit,
  } = GetAgeBracketInfo(config.cpConfig);

  if (DOB >= U15YOBLowerLimit) {
    return "Under 15";
  }
  if (DOB >= U18YOBLowerLimit) {
    return "Under 18";
  }
  if (DOB >= U21YOBLowerLimit) {
    return "Under 21";
  }
  if (DOB >= U25YOBLowerLimit) {
    return "Under 25";
  }
}

const NationalitySelect = ({ value, onChange, SetStudentNationality }) => {
  return (
    <>
      {" "}
      Please pick the option you will provide documents for for verification{" "}
      <Select
        value={value}
        onChange={(value) => {
          onChange(value);
          SetStudentNationality(value);
        }}
      >
        <Option value="Pakistani">Pakistani / NICOP</Option>
        <Option value="Foreign National">Foreign National</Option>
      </Select>
    </>
  );
};

const PhotoFileUploadOld = ({ value, onChange, onUpload }) => {
  const [modalOpen, SetModalOpen] = useState(false);
  const [isProcessing, SetIsProcessing] = useState(false);
  const [photoErrorMessages, SetPhotoErrorMessages] = useState([]);
  // Create a controlled fileList based on the accepted 'value' (dataURL).
  const fileList = value
    ? [
        {
          uid: "-1",
          name: "photo.jpg",
          status: "done",
          url: value,
        },
      ]
    : [];

  return (
    <>
      <PhotoProcessingModal
        isVisible={modalOpen}
        isLoading={isProcessing}
        errors={photoErrorMessages}
        onClose={() => {
          SetModalOpen(false);
        }}
      />
      <ImgCrop rotate aspect={35 / 45}>
        <Upload
          // Pass the controlled fileList to override AntD's internal state
          fileList={fileList}
          maxCount={1}
          accept=".png,.jpg,.jpeg"
          listType="picture-card"
          onRemove={() => {
            onChange(""); // Clear the value on remove
          }}
          // Removing the empty onChange handler

          beforeUpload={async (file) => {
            SetIsProcessing(true);
            SetModalOpen(true);
            SetPhotoErrorMessages([]);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            const dataUrl = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = (e) => resolve(e.target.result);
              reader.readAsDataURL(file);
            });

            let photoErrors = await validatePhotoRequirements(dataUrl);

            if (photoErrors.includes(PhotoErrorMessages.NoFaceDetected)) {
              const { error, message: modelMessage } =
                await loadFaceApiSSDModel();
              if (error) {
                message.error(modelMessage); // Ant Design message
              } else {
                message.success(modelMessage);
                photoErrors = await validatePhotoRequirementsSDDModel(dataUrl);
              }
            }

            SetPhotoErrorMessages(photoErrors);
            SetIsProcessing(false);

            if (photoErrors.length === 0) {
              // SUCCESS: Update parent state, which updates our controlled fileList
              onChange(dataUrl);
              // Return false to stop the network upload
              return false;
            } else {
              // FAILURE: Display error and block the thumbnail
              message.error(`Photo Rejected: ${photoErrors.join(" | ")}`);
              // Use UPLOAD.LIST_IGNORE to reliably block the file from the list
              return Upload.LIST_IGNORE;
            }
          }}
        >
          {/* Only show the button if no file is currently accepted */}
          {fileList.length === 0 && <Button>Select File</Button>}
        </Upload>
      </ImgCrop>
    </>
  );
};
const FileUpload = ({ value, onChange }) => {
  // Function to calculate the initial file list for display
  const getInitialFileList = (currentValue) => {
    // If the value is already a file list object (from FetchOldRowerDetails)
    if (Array.isArray(currentValue)) {
      return currentValue;
    }
    // If the value is the Base64 string (from a previous new manual upload),
    // we can't display it directly, so we return an empty array.
    // If it's null/empty string, also return empty array.
    return [];
  };

  // Use a local state to manage the file list for Ant Design's display mechanism.
  const [localFileList, setLocalFileList] = useState(getInitialFileList(value));

  // Reset local file list if the external 'value' changes back to a file object (e.g., when
  // FetchOldRowerDetails runs again, or form resets).
  // Do NOT run this when 'value' changes to a Base64 string.
  useEffect(() => {
    // Only update local state if the incoming value is an array (file list object)
    // or a falsy value (null/reset). This prevents the Base64 string from triggering
    // a reset to an empty list.
    if (Array.isArray(value) || !value) {
      setLocalFileList(getInitialFileList(value));
    }
  }, [value]);

  return (
    <Upload
      fileList={localFileList} // Use local state for display
      maxCount={1}
      accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      onRemove={() => {
        onChange(null); // Clears Form value
        setLocalFileList([]); // Clears visual list
      }}
      onChange={(info) => {
        // This handler provides immediate visual feedback.
        let newFileList = [...info.fileList];

        // Keep only the last selected file (since maxCount is 1)
        newFileList = newFileList.slice(-1);

        // Set the local state to show the file immediately.
        setLocalFileList(newFileList);
      }}
      beforeUpload={(file) => {
        let reader = new FileReader();
        reader.addEventListener("load", function (e) {
          let text = e.target.result;
          // This ASYNCHRONOUSLY updates the Form.Item value
          // to the Base64 string for saving.
          onChange(text);
        });
        reader.readAsDataURL(file);

        // Prevent Ant Design's default upload action
        return false;
      }}
    >
      <Button>Select File</Button>
    </Upload>
  );
};

/**
 * Fetches a file from a URL and converts it to a Base64 Data URL string.
 * @param {string} url The URL of the file to fetch.
 * @returns {Promise<string|null>} A promise that resolves to the Base64 string or null on failure.
 */
const urlToBase64 = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.statusText}`);
    }
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting URL to Base64:", error);
    return null;
  }
};
